import { render, staticRenderFns } from "./ADstudent.vue?vue&type=template&id=075e033a"
import script from "./ADstudent.vue?vue&type=script&lang=js"
export * from "./ADstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports